<!--suppress ALL -->

<template>
  <el-dialog top="10px"
    width="80%"
    :visible.sync="isVisible"
    :close-on-click-modal="false" :close-on-press-escape="false" :fullscreen="false" :append-to-body="true"
    :title="title">

    <div style="min-width: 500px; height: 500px">
    <div v-if="items.length>0" class="attach-container" style="margin-top: 30px;">
      <el-card class="attach-item" v-for="(item,index) in items" :key="index" style="">
        <div style="margin-bottom: 10px; text-align: left">{{item.time}}</div>
<!--        <div style="height: 100px; overflow: hidden; text-align: left; margin-bottom: 30px">{{item.title}}</div>-->
        <video :poster="item.cover"  preload="none" style="width: 100%; height: auto" :src="item.url" controls="controls">您的浏览器不支持视频播放</video>
        <el-button style="margin-top: 10px" size="small" type="default" icon="el-icon-add" @click="chooseVideo(item)">选择</el-button>
      </el-card>
    </div>
    <div v-else>暂无视频</div>
    </div>

  </el-dialog>
</template>


<script>
export default {
  name: 'VideoChoose',
  data() {
    return {
      title: '视频选择',
      items: [],
      isVisible: false
    }
  },

  components: {
  },
  methods: {
    init() {
      this.isVisible = true
      this.getList()
    },

    chooseVideo(item) {
      this.isVisible = false
      this.$emit('refresh',item.url)
    },

    getList: function () {
      let t = this;
      this.$post(
        {
          context: t,
          path: '/aigc/video/list/',
          params: {
          },
          success: function (data) {
            t.items = data.videos;
          }
        }
      )
    },

  }

}
</script>
<style scoped >
@import '../assets/global.css';

.attach-container {
  display: flex;
  flex-wrap: wrap; /* 关键属性：允许自动换行 */
  gap: 10px; /* 可选：设置项目之间的间距 */
}

.attach-item {
  flex: 1 1 auto; /* 项目可以伸缩 */
  min-width: 24%; /* 设置最小宽度，防止项目过小 */
  max-width: 24%;
  padding: 5px;
  box-sizing: border-box;
  text-align: center;
  margin-bottom: 30px;
}

</style>
